module.exports = "<ui-toolbar-panel title=\"Fertigstellen\">\n  <div layout=\"column\" layout-align=\"center center\" style=\"min-height: 100px\">\n    <md-button class=\"md-raised md-primary\" ng-click=\"fn.showFinishOption()\">Layout abschicken</md-button>\n  </div>\n</ui-toolbar-panel>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/configurator/finish/finish.html
// module id = 437
// module chunks = 0